import { fetchApi } from '../api/digitalVault';
export default async (repository, logger) => await fetchApi({}, `repository/${repository}`, {}, false, logger);
